// extracted by mini-css-extract-plugin
export default {"container":"CheckoutPage_container__f6gpL"};